import { gql } from 'graphql-request';

import { LifestylesSetUUID } from '../lifestylesSetsTypes';

export interface DownloadLifestylesSetQueryResponse {
  uuid: LifestylesSetUUID;
}

export const DOWNLOAD_LIFESTYLES_SET_QUERY = gql`
  mutation DownloadLifestylesSet($uuid: ID!, $deviceNanoId: String!) {
    downloadLifestylesSet(input: { uuid: $uuid, deviceNanoId: $deviceNanoId }) {
      recordUuid
      status
      record {
        uuid
      }
      errors {
        fullMessages
      }
    }
  }
`;
